
import { Component } from 'vue-property-decorator';
import AmountDisplayerFilterable from '@/components/reports-v3/components/filterables/AmountDisplayerFilterable.vue';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import { PermissionsGroup } from '@/store/models.def';
import { getTableName } from '@/worker/db/sqlHelpers';

@Component({
	components: {
		AmountDisplayerFilterable,
	},
})
export default class BpTotalLiabilitiesNumberDisplayer extends FilterWidget {
	public get permissionIds(): PermissionsGroup[] {
		return ['transactions'];
	}

	public filterIds: Array<
		| 'date'
		| 'dateAsOf'
		| 'dateRange'
		| 'stockItems'
		| 'agents'
		| 'customers'
		| 'suppliers'
	> = ['dateAsOf'];

	public amount: number = 0;

	public get expensiveHook() {
		const { selectedAsOfDate } = this;
		return JSON.stringify([selectedAsOfDate]);
	}

	public async expensiveCalc() {
		const table = getTableName('transactions');

		const jobId = this.currentJobId;
		const queryHead = await this._ensureTablesLoaded(['transactions']);
		this.checkInterrupted(jobId);

		this.generateLoadingText(0.5);

		const result = await queryHead.rawQuery(`
			SELECT SUM(TRY_CAST("AMOUNT" AS DOUBLE)) as total
			FROM ${table}
			WHERE TRY_CAST("DOCDATE" AS BIGINT) <= ${this.selectedAsOfDate}
				AND "ACCTYPE" IN ('CL', 'OL', 'LT')
		`);
		this.checkInterrupted(jobId);

		this.amount = (Number(result[0] && result[0].total) || 0) * -1;

		this.saveHistory('amount');
	}
}
